import { Observable, of } from 'rxjs/index';
import { AjaxError } from 'rxjs/internal/observable/dom/AjaxObservable';
import Event from '../Event';
import { catchError } from 'rxjs/internal/operators';
import RequestFailed from '../events/RequestFailed';

// tslint:disable-next-line:typedef
export default (errorEvent: Event) => (observable: Observable<Event>): Observable<Event> =>
    observable.pipe(
        catchError(
            (ajaxError: AjaxError): Observable<Event> => {
                if (ajaxError.status === 401) {
                    return of(new RequestFailed(ajaxError.status));
                } else {
                    return of(errorEvent);
                }
            }
        )
    );



// WEBPACK FOOTER //
// ./src/application/core/backend/catchErrors.ts